import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
import Paragraph from 'components/atoms/Paragraph';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { IStavKorResp, nzKorepsStavApi, nzKorespPlatbaApi } from 'services/nezarazenyUcet/nuZapis';

interface IPlatbaKoresp {}

const PlatbaKoresp: React.FC<IPlatbaKoresp> = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [zadostData, setZadostData] = useState<IStavKorResp>();
    const [errStatus, setErrStatus] = useState<number>();
    const { idzadost } = useParams<{ idzadost: string }>(); // idzadost sebran z urlky

    console.log(idzadost, window.location);

    useEffect(() => {
        setLoading(true);
        nzKorepsStavApi(idzadost)
            .then(data => setZadostData(data))
            .finally(() => setLoading(false));
    }, [idzadost]);

    const onClick = () => {
        setLoading(true);
        nzKorespPlatbaApi(idzadost)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((resp: any) => {
                window.open(resp.urlbankid, '_parent'); // Redirectne uzivatele na stranky platebni brany
            })
            .catch((err: AxiosError) => {
                setErrStatus(err.response?.status);
                setLoading(false);
            });
    };
    return (
        <StatementWrapper pageTitle="">
            <LoadingWrapper loading={loading}>
                {errStatus ? (
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>
                    </Col>
                ) : (
                    <>
                        <h3>
                            <TranslateText>Služba</TranslateText>
                        </h3>
                        <div className="section-zadatel">
                            {zadostData?.zmenosudaj && (
                                <Row>
                                    <TranslateText>
                                        Zápis změny osobních a adresních údajů u majitele nezařazeného účtu
                                    </TranslateText>
                                </Row>
                            )}
                            {zadostData?.zmenbankuc && (
                                <Row>
                                    <TranslateText>
                                        Zápis nebo změna čísla bankovního účtu u majitele nezařazeného účtu
                                    </TranslateText>
                                </Row>
                            )}
                        </div>
                        <Row>
                            <Paragraph text="FORMA_UHRADY" />
                        </Row>
                        <Row>
                            <Col span={24} className="detail">
                                <TranslateText>CELKOVA_CASTKA</TranslateText>: {`${zadostData?.cena},00 Kč`}
                            </Col>
                        </Row>
                        {zadostData?.platnostdo && (
                            <Row>
                                <Col span={24} className="detail">
                                    <TranslateText>Zaplatit do</TranslateText>:{' '}
                                    {moment(zadostData?.platnostdo).format('DD.MM.YYYY')}
                                </Col>
                            </Row>
                        )}
                        <Row className="statement-buttons-row">
                            {!zadostData?.zaplaceno ? (
                                <ButtonComponent htmlType="submit" buttontext="ZAPLATIT" onClick={onClick} />
                            ) : (
                                <p>
                                    Služba byla zaplacena.
                                    <br />
                                    Protokol o provedení služby vám byl poslán na e-mail.
                                </p>
                            )}
                        </Row>
                    </>
                )}
            </LoadingWrapper>
        </StatementWrapper>
    );
};

export default PlatbaKoresp;
